package com.merkost.handpass.admin.components

import androidx.compose.runtime.Composable
import com.merkost.handpass.sharedweb.components.BadgeDensity
import com.merkost.handpass.sharedweb.components.BadgeShape
import com.merkost.handpass.sharedweb.components.BadgeTone
import com.merkost.handpass.sharedweb.components.WebBadge

enum class AdminBadgeVariant { Success, Warning, Error, Neutral, Info }

private fun AdminBadgeVariant.toTone(): BadgeTone = when (this) {
    AdminBadgeVariant.Success -> BadgeTone.Success
    AdminBadgeVariant.Warning -> BadgeTone.Warning
    AdminBadgeVariant.Error -> BadgeTone.Danger
    AdminBadgeVariant.Info -> BadgeTone.Info
    AdminBadgeVariant.Neutral -> BadgeTone.Neutral
}

@Composable
fun AdminBadge(
    label: String,
    variant: AdminBadgeVariant,
    compact: Boolean = false,
    showDot: Boolean = true,
    shape: BadgeShape = BadgeShape.Pill,
) {
    WebBadge(
        label = label,
        tone = variant.toTone(),
        density = if (compact) BadgeDensity.Compact else BadgeDensity.Default,
        shape = shape,
        showDot = showDot,
    )
}

@Composable
fun AdminStatusBadge(label: String, variant: AdminBadgeVariant) {
    AdminBadge(label = label, variant = variant, compact = true, shape = BadgeShape.Tag)
}

@Composable
fun AccountStatusBadge(status: String) {
    val variant = when (status.lowercase()) {
        "active", "published", "sold" -> AdminBadgeVariant.Success
        "warned" -> AdminBadgeVariant.Warning
        "suspended" -> AdminBadgeVariant.Warning
        "banned", "deleted" -> AdminBadgeVariant.Error
        "pending", "expired" -> AdminBadgeVariant.Neutral
        "actioned" -> AdminBadgeVariant.Info
        "dismissed" -> AdminBadgeVariant.Neutral
        else -> AdminBadgeVariant.Neutral
    }
    AdminStatusBadge(label = status, variant = variant)
}
